import { render, staticRenderFns } from "./UserCardContent.vue?vue&type=template&id=e05f2a70&"
import script from "./UserCardContent.vue?vue&type=script&lang=js&"
export * from "./UserCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports